import React, { useEffect, useState, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import './GetQuotes.css';
import { useNavigate } from "react-router-dom";
import URLstateContext from "../../../../provider/CommonContext";
import { useLocalStorage } from "../../../utils/useLocalStorage";
import CallTrackApi from "../../../Activity_Track/CallTrackApi";

function GetQuotes() {
    let navigate = useNavigate();
    const [suggestions, setSuggestions] = useState([]);
    const { BaseURL, setcompserachcocode } = useContext(URLstateContext);
    const [setTextval, setText] = useState([]);
    const [optionInfo, setOptionInfo] = useState('Get Quotes');
    const [compCodeBef, setCompCodeBef] = useState('');
    const [compCodeName, setCompCodeName] = useState('');
    const [compError, setCompError] = useState('');
    const [showResults, setShowResults] = useState(false);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const getCompName = compCodeName.replace(/ /g, '-').replace('&', 'and').replace('+', '');
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    let compflag = true;

    const onChangeHandler = event => {
        setCompError('')
        let matches = [];
        setText(event.target.value);
        var nameComp = event.target.value;
        if (nameComp.length > 1) {
            Loadcompany(setTextval);
        }
        else {
            setShowResults(false);
            DataFilter = [];
            setSuggestions(DataFilter);
        }
    };
    function Loadcompany(setTextval) {
        setShowResults(true);
        const getSectorListUrl = BaseURL + "companysearch/" + setTextval;

        fetch(`${getSectorListUrl}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;

                getval = myrepo;
                for (var i = 0; i < getval.length; i++) {
                    DataFilter.push({
                        CompName: getval[i]['lname'],
                        COCODE: getval[i]['Co_Code'],
                        Exchange: getval[i]['Exchange']
                    });
                }

                matchcomp = DataFilter;
                setSuggestions(matchcomp);

            })
            .catch((error) => {
                // console.log(error);
            });
    }
    const companyClick = (paramcode, paramname, paramexchange) => {
        setShowResults(false);
        setCompCodeBef(paramcode);
        setCompCodeName(paramname);
        document.getElementById('compTextGet').value = paramname;
    }

    const handleClick = () => {
        if (getCompName !== "") {
            if (optionInfo === "Company Background" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Company-Background/" + getCompName);
            }
            if (optionInfo === "Board of Directors" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Board-of-Directors/" + getCompName);
            }
            if (optionInfo === "Balance Sheet" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Balance-Sheet/" + getCompName);
            }
            if (optionInfo === "Profit & Loss Accounts" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Profit-Loss-Accounts/" + getCompName);
            }
            if (optionInfo === "Quarterly Results" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Quarterly-Results/" + getCompName);
            }
            if (optionInfo === "Key Financial Ratios" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Key-Financial-Ratios/" + getCompName);
            }
            if (optionInfo === "Share Price" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Share-Price/" + getCompName);
            }
            if (optionInfo === "Share Holding Pattern" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Share-Holding-Pattern/" + getCompName);
            }
            if (optionInfo === "Intraday / EOD charts" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Intraday-charts/" + getCompName);
            }
            if (optionInfo === "Cash Flow" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Cash-Flow/" + getCompName);
            }
            if (optionInfo === "Directors Reports" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Directors-Reports/" + getCompName);
            }
            if (optionInfo === "Score Board" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Score-Board/" + getCompName);
            }
            if (optionInfo === "MF Holdings" && getCompName != "-undefined") {
                navigate("/CompanyProfile/MF-Holdings/" + getCompName);
            }
            if (optionInfo === "Name Change" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Name-Change/" + getCompName);
            }
            if (optionInfo === "Company News" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Company-News/" + getCompName);
            }
            if (optionInfo === "Peer Comparison" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Peer-Comparison/" + getCompName);
            }
            if (optionInfo === "Bonus History" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Bonus-History/" + getCompName);
            }
            if (optionInfo === "Dividend" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Dividend/" + getCompName);
            }
            if (optionInfo === "Rights" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Rights/" + getCompName);
            }
            if (optionInfo === "Announcements" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Announcements/" + getCompName);
            }
            if (optionInfo === "Board Meeting" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Board-Meeting/" + getCompName);
            }
            if (optionInfo === "Book Closure" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Book-Closure/" + getCompName);
            }
            if (optionInfo === "Prev Quarter Comp" && getCompName != "-undefined") {
                navigate("/CompanyProfile/Prev-Quarter-Comp/" + getCompName);
            }
            if (optionInfo === "Company Snapshot" && getCompName != "-undefined") {
                setcocode(compCodeBef);
                window.open("/stocks/" + getCompName.toLowerCase(), '_blank');
            }
        } else {
                setCompError("Please Select Company Name");
                compflag = false;
        }
    }
    CallTrackApi("Companyprofile Get Quotes",window.location.href);
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Get Quotes</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='gainer-loser-sc'>
                            <div className='gainer-headerQuote'>
                                <h2><span>Get Quotes</span></h2>
                            </div>

                        </section>
                    </Col>
                </Row>
            </Container>

            <section className="explore-equities get-quotes-main">
                <Container className="table-boxQuote">
                    <Row>
                        <Col lg={{ span: 8, offset: 2 }} md={{ span: 10, offset: 1 }}>
                            <p>The Pages within this section are Company Specific.<br></br>
                                We request you to enter atleast three characters of Company Name for the display of data.
                            </p>
                            <div className='quotes-main'>
                                <label>Enter Company Name</label>
                                <input id="compTextGet" type="text" placeholder='Company Name' onChange={onChangeHandler}></input>
                                {showResults ?
                                    <div className="getDrop">
                                        {suggestions && suggestions.map((suggestion, i) =>
                                            <div className="suggestion col-md-12 justify-content-md-center padd-content" onClick={() => companyClick(suggestion.COCODE, suggestion.CompName, suggestion.Exchange)}>{suggestion.CompName}</div>
                                        )}
                                    </div> : ''}
                                    {compError != '' && <h6 className="errormsgComGet">{compError}</h6>}
                            </div>
                            
                            <div className='quotes-main quotes-select'>
                                <label> Choose Your Landing Page</label>
                                <select onChange={(event) => { setOptionInfo(event.target.value) }}>
                                    <option>Select</option>
                                    <option value={"Company Background"}>Company Background</option>
                                    <option value={"Board of Directors"}>Board of Directors</option>
                                    <option value={"Balance Sheet"}>Balance Sheet</option>
                                    <option value={"Profit & Loss Accounts"}>Profit & Loss Accounts</option>
                                    <option value={"Quarterly Results"}>Quarterly Results</option>
                                    <option value={"Key Financial Ratios"}>Key Financial Ratios</option>
                                    <option value={"Share Price"}>Share Price</option>
                                    <option value={"Intraday / EOD charts"}>Intraday / EOD charts</option>
                                    <option value={"Cash Flow"}>Cash Flow</option>
                                    <option value={"Company Snapshot"}>Company Snapshot</option>
                                    <option value={"Share Holding Pattern"}>Share Holding Pattern</option>
                                    <option value={"Directors Reports"}>Directors Reports</option>
                                    <option value={"MF Holdings"}>MF Holdings</option>
                                    <option value={"Name Change"}>Name Change</option>
                                    <option value={"Company News"}>Company News</option>
                                    <option value={"Peer Comparison"}>Peer Comparison</option>
                                    <option value={"Prev Quarter Comp"}>Prev Quarter Comp</option>
                                    <option value={"Bonus History"}>Bonus History</option>
                                    <option value={"Dividend"}>Dividend</option>
                                    <option value={"Rights"}>Rights</option>
                                    <option value={"Announcements"}>Announcements</option>
                                    <option value={"Board Meeting"}>Board Meeting</option>
                                    <option value={"Book Closure"}>Book Closure</option>
                                </select>
                            </div>
                          
                            <div className='get-quote-btn'>
                                <button className="goComp" onClick={handleClick}>GO</button>
                            </div>

                        </Col>

                    </Row>
                </Container>
            </section>
        </>
    );
}

export default GetQuotes;